const PRE_TABLE_CLASS_NAMA = 'config-row-height-table table-row-';
export const ROW_HEIGHT_CLASS_NAME_MAP: Record<string, string> = {
    high: `${PRE_TABLE_CLASS_NAMA}high-height`,
    middle: `${PRE_TABLE_CLASS_NAMA}middle-height`,
    low: `${PRE_TABLE_CLASS_NAMA}low-height`,
    auto: `${PRE_TABLE_CLASS_NAMA}auto-height`
};
